export default "__VITE_ASSET__QqZ4vlFR__";